import {
  HTTP_UPDATEBUHEAD_FETCHING,
  HTTP_UPDATEBUHEAD_SUCCESS,
  HTTP_UPDATEBUHEAD_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";

//Update Special
export const setStateupdateBuheadToFetching = () => ({
  type: HTTP_UPDATEBUHEAD_FETCHING,
});

export const setStateupdateBuheadToSuccess = (payload) => ({
  type: HTTP_UPDATEBUHEAD_SUCCESS,
  payload,
});

export const setStateupdateBuheadToFailed = (payload) => ({
  type: HTTP_UPDATEBUHEAD_FAILED,
});

// export const updateBudgetOById = (budgetoid, memid, item) => {
export const updateBuheadById = (
  countryid,
  companyid,
  brandid,
  departmentid,
  yearid,
  item
) => {
  return async (dispatch) => {
    dispatch(setStateupdateBuheadToFetching());
    try {
      await httpClient.put(
        `${server.UPDATEBUHEAD_URL}/${countryid}/${companyid}/${brandid}/${departmentid}/${yearid}`,
        item
      );

      dispatch(setStateupdateBuheadToSuccess("success"));
    } catch (error) {
      dispatch(setStateupdateBuheadToFailed());
    }
  };
};
